export const commonSearchFields = (self) => {
  const { formName, needCustomer, needHouse, needParkspot, needAccount, needConduct } = self.commonSearchOption || {}
  const fields = []
  if (needCustomer) {
    fields.push({
      label: '公司名称',
      prop: '$customerId',
      hide: true,
      display: false,
      searchOrder: 10000,
      search: true,
      suffixIcon: 'el-icon-search',
      readonly: true,
      clearable: true,
      focus: ({ value, column }) => {
        self?.$openSelectCustomer()
      },
      change: ({ value, column, item, dic }) => {
        console.log('value, column, item, dic: ', value, column, item, dic)
      }
    })
  }
  if (needHouse) {
    fields.push(...[
      {
        label: '可选房屋',
        prop: 'houseCode',
        hide: true,
        display: false,
        searchOrder: 9981,
        search: true,
        type: 'select',
        dicData: () => self?.houseList,
        props: {
          label: 'houseLocation',
          value: 'houseCode'
        },
        clearable: true,
        change: ({ value, column, item, dic }) => {
          console.log('value, column, item, dic: ', value, column, item, dic)
          if (!value || !self || !item) return
          self.searchForm.houseCode = item?.houseCode
          self.searchForm.$houseCode = item?.houseLocation
        }
      },
      {
        label: '房屋名称',
        prop: '$houseCode',
        hide: true,
        display: false,
        searchOrder: 9980,
        search: true,
        readonly: true,
        suffixIcon: 'el-icon-search',
        clearable: true,
        focus: ({ value, column }) => {
          self?.$openSelectHouse()
        },
        change: ({ value, column, item, dic }) => {
          if (!value) {
            self.searchForm.houseCode = undefined
            self.searchForm.$houseCode = undefined
          }
        }
      }
    ])
  }

  if (needParkspot) {
    fields.push(...[
      {
        label: '可选车位',
        prop: 'parkspotCode',
        hide: true,
        display: false,
        searchOrder: 9971,
        search: true,
        type: 'select',
        dicData: () => self?.parkspotList,
        props: {
          label: 'spotLocation',
          value: 'spotCode'
        },
        change: ({ value, column, item, dic }) => {
          if (!value || !self || !item) return
          self.searchForm.parkspotCode = item?.spotCode
          self.searchForm.$parkspotCode = item?.spotLocation
        }
      },
      {
        label: '车位名称',
        prop: '$parkspotCode',
        hide: true,
        display: false,
        searchOrder: 9970,
        search: true,
        suffixIcon: 'el-icon-search',
        clearable: true,
        focus: ({ value, column }) => {
          self?.$openSelectCarport()
        },
        change: ({ value, column, item, dic }) => {
          if (!value) {
            self.searchForm.parkspotCode = undefined
            self.searchForm.$parkspotCode = undefined
          }
        }
      }
    ])
  }

  if (needAccount) {
    fields.push({
      label: '科目名称',
      prop: '$accountCode',
      hide: true,
      display: false,
      searchOrder: 9960,
      search: true,
      suffixIcon: 'el-icon-search',
      clearable: true,
      focus: ({ value, column }) => {
        self?.$openSelectAccount()
      },
      change: ({ value, column, item, dic }) => {
        if (!value) {
          self.searchForm.accountCode = undefined
          self.searchForm.$accountCode = undefined
        }
      }
    },)
  }

  if (needConduct) {
    fields.push({
      label: '标准名称',
      prop: '$conductCode',
      hide: true,
      display: false,
      searchOrder: 9950,
      search: true,
      suffixIcon: 'el-icon-search',
      clearable: true,
      focus: ({ value, column }) => {
        self?.$openSelectConduct()
      },
      change: ({ value, column, item, dic }) => {
        if (!value) {
          self.searchForm.conductCode = undefined
          self.searchForm.$conductCode = undefined
        }
      }
    },)
  }

  return fields
}
